import React                           from 'react';
import { Divider, Group, Stack, Text } from '@mantine/core';
import { DxbPriceSummary }             from '@features/booking/components/Summary/DxbPriceSummary';
import useIsMounted                    from '@hooks/use-is-mounted';
import { useBookingState }             from "@core/providers/BookingStateProvider";


export const PriceSummary: React.FC = () => {

    const isMounted = useIsMounted();

    const { priceCalculations } = useBookingState();

    const nightsText = `AED ${priceCalculations.pricePerNight} x ${priceCalculations.totalNights} Nights`;
    const totalPriceText = `AED ${priceCalculations.totalPrice}`;
    const dxbPriceText = `AED ${priceCalculations.dxbTotalPrice}`;
    const grandTotalText = `AED ${priceCalculations.grandTotalPrice}`;

    return isMounted && (
        <Stack>
            <Text align="center" size="sm" mb={30}>You won't be charged yet</Text>

            <Group grow={true} spacing={0}>
                <Text align="left">Booking Price
                    <Text align="left" size={10}>{nightsText}</Text>
                </Text>
                <Text align="right">{totalPriceText}</Text>
            </Group>

            <DxbPriceSummary/>

            {/*<Group grow={true} spacing={0}>
                <Text align="left">TOTAL</Text>
                <Text align="right">{dxbPriceText}</Text>
            </Group>*/}

            {/*<Group grow={true} spacing={0}>
                <Text align="left">[FOR DEBUGGING] DXB TOTAL</Text>
                <Text align="right">{dxbPriceText}</Text>
            </Group>*/}

            <Divider ml={-20} mr={-20} mt={20} mb={20}/>

            <Group grow={true} spacing={0}>
                <Text align="left">Grand TOTAL</Text>
                <Text align="right">{grandTotalText}</Text>
            </Group>

            <Group grow={false} spacing={0} mt={20}>
                <Text size="xs">** Tourism fees only applies to the first 30 nights of your stay.</Text>
                <Text size="xs">** Security deposits are refundable.</Text>
            </Group>

        </Stack>
    )

}
